export interface GossipSection {
  title: string;
  body: string[];
}

export interface GossipArticle {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  summary: string;
  cover: string;
  coverAlt: string;
  date: string;
  editor: string;
  readCount: number;
  tags: string[];
  isHot: boolean;
  isFeatured: boolean;
  sections: GossipSection[];
}

export interface GossipCategory {
  slug: string;
  name: string;
  desc: string;
  icon: string;
  count: number;
}

export interface GossipFaq {
  q: string;
  a: string;
}

export const siteInfo = {
  name: "瓜田福利社",
  tagline: "热门吃瓜内容，一站看全",
  slogan: "把散落各处的热瓜，整理成一份份看得完的合集",
  intro:
    "瓜田福利社是一个专注娱乐与网络热点内容的聚合盘点平台。我们把分散在各个平台的热门爆料、综艺名场面、剧集看点、网络热议整理成结构清晰的「合集」「盘点」「汇总版」，让你不必四处翻找，点开就能一次看完当天的重点内容。",
  email: "hello@guatianfulishe.com",
  replyTime: "工作日 24 小时内回复",
  updateFreq: "每日更新 3-5 篇盘点",
  founded: "2021 年",
};

export const categories: GossipCategory[] = [
  {
    slug: "entertainment",
    name: "娱乐圈",
    desc: "行业动态、幕后花絮与公开活动的现场看点整理",
    icon: "ri-sparkling-2-line",
    count: 128,
  },
  {
    slug: "film-tv",
    name: "影视综艺",
    desc: "剧集与综艺的名场面、看点与口碑盘点",
    icon: "ri-movie-2-line",
    count: 96,
  },
  {
    slug: "net-buzz",
    name: "网络热议",
    desc: "社交平台上的热门话题、流行语与挑战整理",
    icon: "ri-chat-smile-2-line",
    count: 214,
  },
  {
    slug: "fashion",
    name: "时尚生活",
    desc: "红毯造型、穿搭趋势与生活方式话题盘点",
    icon: "ri-t-shirt-2-line",
    count: 74,
  },
  {
    slug: "music",
    name: "音乐现场",
    desc: "音乐节、演唱会与舞台表演的高光时刻合集",
    icon: "ri-music-2-line",
    count: 61,
  },
  {
    slug: "sports",
    name: "体育竞技",
    desc: "赛场逆转、绝杀瞬间与赛事话题的完整回顾",
    icon: "ri-basketball-line",
    count: 53,
  },
];

export const articles: GossipArticle[] = [
  {
    id: "variety-show-highlights-2025",
    title: "年度综艺名场面合集：笑点与泪点一次看完",
    category: "影视综艺",
    categorySlug: "film-tv",
    summary:
      "从户外竞技到慢生活观察，今年的综艺贡献了太多让人反复回看的瞬间。这份合集按「笑点」「泪点」「名台词」三条线整理，帮你把一整年的高光一次补齐。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20flatlay%20of%20colorful%20vintage%20television%20remote%20popcorn%20and%20film%20clapperboard%20on%20cream%20paper%20background%2C%20soft%20studio%20lighting%2C%20magazine%20style%20still%20life%2C%20terracotta%20and%20amber%20tones&width=800&height=600&seq=gt-variety-01&orientation=landscape",
    coverAlt: "年度综艺名场面合集封面，暖色调的电视机与爆米花静物",
    date: "2025-08-28",
    editor: "编辑 小林",
    readCount: 18420,
    tags: ["综艺盘点", "名场面", "年度合集"],
    isHot: true,
    isFeatured: true,
    sections: [
      {
        title: "先看笑点：今年被反复剪进短视频的十个画面",
        body: [
          "今年综艺最明显的变化，是「真实的反应」比精心设计的桥段更容易出圈。户外竞技类节目里，嘉宾在任务失败后的即时吐槽、慢生活节目里突然安静下来的尴尬瞬间，往往比剧本更有传播力。",
          "把这些画面按出现频率排一排会发现，能反复被剪成短视频的，基本都是「意料之外、情理之中」的瞬间：一句没接住的话、一个意外的道具故障、一次全员沉默的冷场。这类内容不依赖明星光环，反而更容易让普通观众代入。",
        ],
      },
      {
        title: "再看泪点：慢综艺为什么总能戳中人",
        body: [
          "慢生活观察类节目今年的口碑明显回暖，原因在于它们把镜头更多地交给了「日常」。一顿饭怎么做、一次夜谈聊到什么、离别的车站有没有回头，这些细节构成了情绪的真正落点。",
          "比起刻意煽情，观众更愿意为克制买单。当节目不再急着给结论，而是把时间和空间留给嘉宾自己，泪点往往就在一个不经意的停顿里出现。",
        ],
      },
      {
        title: "名台词整理：一句话记住一整季",
        body: [
          "好台词的标准不是多华丽，而是多准确。今年被反复引用的几句，共同点是足够口语、又能精准概括某种状态，比如面对压力时的自嘲、面对选择时的犹豫。",
          "如果你只想快速回顾，建议直接看名台词部分，再挑感兴趣的片段回看原片，这样效率最高。",
        ],
      },
    ],
  },
  {
    id: "summer-drama-roundup",
    title: "暑期档剧集盘点：热度与口碑都稳住的几部作品",
    category: "影视综艺",
    categorySlug: "film-tv",
    summary:
      "暑期档历来是剧集竞争最激烈的档期。这份盘点不堆数据，只聊每部作品真正值得看的地方，以及适合什么样的人入坑。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20stacked%20vintage%20film%20reels%20and%20a%20cup%20of%20tea%20on%20linen%20cloth%20with%20cream%20background%2C%20amber%20and%20terracotta%20color%20palette%2C%20soft%20natural%20window%20light%2C%20magazine%20photography&width=800&height=600&seq=gt-drama-02&orientation=landscape",
    coverAlt: "暑期档剧集盘点封面，暖色调胶片与茶杯静物",
    date: "2025-08-20",
    editor: "编辑 阿澈",
    readCount: 15230,
    tags: ["剧集盘点", "暑期档", "追剧指南"],
    isHot: true,
    isFeatured: true,
    sections: [
      {
        title: "年代质感类：慢热，但后劲足",
        body: [
          "这类作品往往前三集节奏偏慢，需要一点耐心。它们的优势在于人物关系扎实、场景还原用心，越看到后面越能感受到铺垫的价值。",
          "适合喜欢细水长流、愿意跟着角色一起成长的观众。如果你习惯倍速看剧，可能会错过很多藏在细节里的信息。",
        ],
      },
      {
        title: "悬疑推理类：信息密度高，别快进",
        body: [
          "悬疑剧的核心是用信息控制节奏。今年几部表现不错的作品，共同点是线索给得克制、反转收得住，不会为了刺激而强行加戏。",
          "建议一口气连看两到三集，观感会明显好于每天追一集，因为很多伏笔需要连续记忆才能串起来。",
        ],
      },
      {
        title: "都市生活类：下饭友好，共鸣点多",
        body: [
          "都市生活剧最大的优势是「贴近」。职场沟通、租房搬家、和家人的相处，这些内容不需要理解成本，随手点开就能看。",
          "这类作品适合当作吃饭时的背景，也适合在通勤路上碎片化观看，对时间安排比较友好。",
        ],
      },
    ],
  },
  {
    id: "internet-slang-of-the-year",
    title: "网络流行语年度盘点：这些话你今年说过几句",
    category: "网络热议",
    categorySlug: "net-buzz",
    summary:
      "流行语是观察一年情绪最直接的窗口。我们从社交平台的讨论里整理了今年出现频率最高的表达，并说说它们为什么会流行。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20flatlay%20of%20speech%20bubble%20cutouts%20and%20handwritten%20notes%20on%20cream%20paper%2C%20amber%20and%20olive%20accents%2C%20soft%20studio%20lighting%2C%20magazine%20still%20life%20composition&width=800&height=600&seq=gt-slang-03&orientation=landscape",
    coverAlt: "网络流行语年度盘点封面，暖色调对话气泡纸片静物",
    date: "2025-08-14",
    editor: "编辑 小满",
    readCount: 26780,
    tags: ["流行语", "网络热议", "年度盘点"],
    isHot: true,
    isFeatured: false,
    sections: [
      {
        title: "为什么一个词能突然流行",
        body: [
          "流行语的扩散通常遵循一个简单的路径：先在某个小圈子内被高频使用，然后因为恰好能概括一种普遍情绪而被大规模转发，最后进入日常对话。",
          "能留下来的表达，往往不是最精巧的，而是最省力的。用一个词代替一整段解释，这就是它们真正的价值。",
        ],
      },
      {
        title: "今年的高频表达有哪些特点",
        body: [
          "今年流行的表达整体更「温和」。相比尖锐的吐槽，人们更倾向于用自嘲、调侃的方式表达态度，这既降低了冲突感，也让沟通更轻松。",
          "另一个特点是画面感更强。很多流行语本身就带有场景，说出口时听的人能立刻脑补出对应的画面，传播自然更快。",
        ],
      },
      {
        title: "想跟上话题，不必硬背",
        body: [
          "流行语是工具，不是考试内容。与其刻意记忆，不如多看看评论区，语言的生命力永远来自真实使用。",
          "如果你在做内容运营，建议建立自己的表达库，记录下每次看到时觉得「用得真准」的说法，比临时找词有效得多。",
        ],
      },
    ],
  },
  {
    id: "music-festival-highlights",
    title: "音乐节高光时刻合集：现场氛围为什么这么顶",
    category: "音乐现场",
    categorySlug: "music",
    summary:
      "从万人合唱到即兴返场，音乐节的魅力很难用文字完全还原。这份合集整理了今年现场最出圈的几个瞬间，也聊聊舞台是怎么把气氛推上去的。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20vintage%20microphone%20and%20vinyl%20record%20on%20cream%20linen%20with%20amber%20stage%20light%20glow%2C%20terracotta%20tones%2C%20soft%20studio%20lighting%2C%20magazine%20photography&width=800&height=600&seq=gt-music-04&orientation=landscape",
    coverAlt: "音乐节高光时刻合集封面，暖色调麦克风与黑胶唱片静物",
    date: "2025-08-06",
    editor: "编辑 老周",
    readCount: 9860,
    tags: ["音乐现场", "音乐节", "现场盘点"],
    isHot: false,
    isFeatured: false,
    sections: [
      {
        title: "合唱瞬间：观众才是第二主唱",
        body: [
          "音乐节最容易被记住的画面，往往不是舞台上的独唱，而是全场跟唱。当一整片人声盖过音响，那种共振感是任何录音都还原不了的。",
          "很多乐队会特意把副歌留白，交给观众接上。这种设计看起来简单，实际非常考验对歌迷熟悉度的判断。",
        ],
      },
      {
        title: "舞台设计：灯光是怎么帮上忙的",
        body: [
          "好的舞台设计不会喧宾夺主，而是服务于情绪曲线。前段用低亮度聚光收拢注意力，副歌时整体提亮、配合观众手机灯，气氛就自然上去了。",
          "今年不少现场开始减少复杂的机械装置，转而把预算放在声音质量上，观众的反馈普遍不错。",
        ],
      },
      {
        title: "去现场前值得做的准备",
        body: [
          "提前查好场地动线、准备好耳塞、穿舒适的鞋，这些看起来琐碎的小事，直接决定你当天的体验。",
          "另外建议提前熟悉歌单，能跟唱的段落越多，现场参与感越强。",
        ],
      },
    ],
  },
  {
    id: "red-carpet-looks-of-the-year",
    title: "红毯造型盘点：今年最出圈的几套造型长什么样",
    category: "时尚生活",
    categorySlug: "fashion",
    summary:
      "红毯造型每年都会被反复讨论。这份盘点跳过热搜，从剪裁、色彩和整体氛围三个角度，聊聊什么样的造型能真正被记住。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20flatlay%20of%20fashion%20sketches%20fabric%20swatches%20and%20ribbon%20on%20cream%20paper%2C%20terracotta%20and%20amber%20palette%2C%20soft%20studio%20lighting%2C%20magazine%20still%20life&width=800&height=600&seq=gt-fashion-05&orientation=landscape",
    coverAlt: "红毯造型盘点封面，暖色调时装草图与布料色卡静物",
    date: "2025-07-30",
    editor: "编辑 小林",
    readCount: 11240,
    tags: ["时尚盘点", "红毯造型", "穿搭趋势"],
    isHot: false,
    isFeatured: true,
    sections: [
      {
        title: "剪裁：决定造型的上限",
        body: [
          "红毯上最容易被记住的造型，几乎都有一个共同点——轮廓清晰。无论是利落的直线条还是夸张的廓形，只要结构明确，站在人群里就会被看到。",
          "相比之下，元素堆得太多反而容易失焦。配饰、印花、层次如果都想抢镜，观感就会变得杂乱。",
        ],
      },
      {
        title: "色彩：低饱和反而更耐看",
        body: [
          "今年红毯上低饱和度的造型明显更多，米白、暖棕、雾感红成为高频选择。这类颜色对肤色包容度高，也更容易和背景形成舒服的对比。",
          "如果想在照片里更突出，可以只在某一个配饰上使用高饱和色，用小面积提亮代替整体冲击。",
        ],
      },
      {
        title: "氛围感：造型之外的细节",
        body: [
          "真正的红毯高手，赢在整体状态。发型、妆容、站姿甚至走动的节奏，都会影响造型最终的呈现效果。",
          "所以与其纠结单品，不如先把整体比例和状态调到位，这比任何夸张的设计都更有效。",
        ],
      },
    ],
  },
  {
    id: "golden-supporting-roles",
    title: "影视剧黄金配角盘点：那些让人一眼记住的绿叶",
    category: "影视综艺",
    categorySlug: "film-tv",
    summary:
      "一部好剧离不开配角的支撑。这份盘点关注那些戏份不多、却总能用一个眼神或一句话把角色立住的表现，也聊聊他们为什么难被替代。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20vintage%20theater%20masks%20and%20film%20script%20pages%20on%20cream%20desk%2C%20amber%20and%20terracotta%20tones%2C%20soft%20studio%20light%2C%20magazine%20photography&width=800&height=600&seq=gt-support-06&orientation=landscape",
    coverAlt: "黄金配角盘点封面，暖色调戏剧面具与剧本静物",
    date: "2025-07-24",
    editor: "编辑 阿澈",
    readCount: 8720,
    tags: ["剧集盘点", "配角", "演技"],
    isHot: false,
    isFeatured: false,
    sections: [
      {
        title: "配角为什么难演",
        body: [
          "配角最大的挑战是「在有限篇幅里建立可信度」。他们没有成长线的铺垫，必须在很短的出场里让观众相信这个人是真实存在的。",
          "因此优秀的配角表演往往非常克制，靠细节而不是靠情绪高点取胜。",
        ],
      },
      {
        title: "被记住的三种方式",
        body: [
          "第一种是功能性出彩，比如关键信息提供者，出场就推动情节；第二种是情绪性出彩，负责替观众说出心里话；第三种是形象性出彩，靠独特的气质让人过目不忘。",
          "三种方式没有高下之分，能对应剧情需要、完成得干净利落的，就是好表演。",
        ],
      },
      {
        title: "看剧时可以留意的细节",
        body: [
          "下次看剧时可以注意配角的反应镜头——当主线人物在说话时，背景里的人是什么表情。这些不抢戏的细节，往往最能体现剧组的用心程度。",
        ],
      },
    ],
  },
  {
    id: "sports-comeback-moments",
    title: "体育赛事名场面合集：逆转与绝杀是怎么发生的",
    category: "体育竞技",
    categorySlug: "sports",
    summary:
      "体育最迷人的地方在于结果永远不到最后一秒不算数。这份合集回顾了今年赛场上几次经典逆转，并拆解它们背后的战术与心态变化。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20vintage%20stopwatch%20whistle%20and%20scoreboard%20sketch%20on%20cream%20paper%2C%20amber%20and%20olive%20tones%2C%20soft%20studio%20lighting%2C%20magazine%20composition&width=800&height=600&seq=gt-sports-07&orientation=landscape",
    coverAlt: "体育名场面合集封面，暖色调秒表与哨子静物",
    date: "2025-07-18",
    editor: "编辑 老周",
    readCount: 7340,
    tags: ["体育盘点", "名场面", "逆转"],
    isHot: false,
    isFeatured: false,
    sections: [
      {
        title: "逆转从来不是运气",
        body: [
          "看起来突然的翻盘，往前倒推往往能看到清晰的迹象：一次成功的防守调整、一个替补的及时站出来、或者对手体能的明显下滑。",
          "所谓奇迹，多数是准备充分的一方等到了机会。",
        ],
      },
      {
        title: "心态的分水岭",
        body: [
          "落后时最危险的从来不是比分，而是节奏被打乱。能稳住节奏的队伍，才有机会等到反扑的窗口。",
          "这也是为什么很多教练在暂停时只强调一件事：把球运转起来，先把简单的回合做好。",
        ],
      },
      {
        title: "值得反复看的几个回合",
        body: [
          "建议重点回看最后三分钟的处理球，那几分钟的选择往往决定了整场比赛的走向，也是最能看出球队性格的地方。",
        ],
      },
    ],
  },
  {
    id: "variety-game-segments",
    title: "综艺游戏环节盘点：笑到停不下来的那些设计",
    category: "影视综艺",
    categorySlug: "film-tv",
    summary:
      "好的游戏环节能让所有人放松下来。这份盘点整理了今年最有效的几类游戏设计，也说说它们为什么好笑以及为什么好笑很难复制。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20flatlay%20of%20colorful%20board%20game%20pieces%20dice%20and%20cards%20on%20cream%20linen%2C%20terracotta%20amber%20and%20olive%20accents%2C%20soft%20studio%20lighting%2C%20magazine%20still%20life&width=800&height=600&seq=gt-game-08&orientation=landscape",
    coverAlt: "综艺游戏环节盘点封面，暖色调桌游道具静物",
    date: "2025-07-10",
    editor: "编辑 小满",
    readCount: 6980,
    tags: ["综艺盘点", "游戏环节", "名场面"],
    isHot: false,
    isFeatured: false,
    sections: [
      {
        title: "规则简单，才有意外空间",
        body: [
          "被记住的游戏，规则通常一句话就能说清。规则越简单，嘉宾的判断空间越大，越容易出现计划之外的反应。",
          "反过来，规则复杂的游戏往往把嘉宾的注意力都占满了，笑点反而变少。",
        ],
      },
      {
        title: "输赢不重要，过程要看得到",
        body: [
          "好的游戏设计会刻意放大过程。它不会只公布一个结果，而是把尝试、失败、再尝试的每一步都呈现出来。",
          "观众真正代入的，是那种「我上我也这样」的笨拙感。",
        ],
      },
      {
        title: "为什么同样的游戏换一批人就不好笑",
        body: [
          "综艺效果一半来自设计，一半来自人。嘉宾之间的熟悉度、愿意放下的偶像包袱、以及彼此的节奏感，都是无法照搬的。",
          "这也是为什么很多游戏看着简单，复刻起来却很难成功。",
        ],
      },
    ],
  },
  {
    id: "social-media-challenges",
    title: "社交平台热门挑战盘点：全民都在玩的是什么",
    category: "网络热议",
    categorySlug: "net-buzz",
    summary:
      "每隔一段时间，社交平台上就会冒出一个全民参与的挑战。这份盘点梳理了今年流传最广的几类挑战，并分析它们流行的底层逻辑。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20flatlay%20of%20smartphone%20ring%20light%20and%20sticky%20notes%20on%20cream%20desk%2C%20terracotta%20and%20amber%20tones%2C%20soft%20studio%20lighting%2C%20magazine%20still%20life&width=800&height=600&seq=gt-challenge-09&orientation=landscape",
    coverAlt: "社交平台热门挑战盘点封面，暖色调手机与补光灯静物",
    date: "2025-07-02",
    editor: "编辑 小满",
    readCount: 8190,
    tags: ["网络热议", "挑战", "流行趋势"],
    isHot: false,
    isFeatured: false,
    sections: [
      {
        title: "低门槛是扩散的前提",
        body: [
          "能火起来的挑战，几乎都不需要专业设备或技能。一部手机、一个动作、一段音乐就能完成，参与成本越低，扩散速度越快。",
        ],
      },
      {
        title: "可二创，才有生命力",
        body: [
          "同一个挑战能持续多久，取决于它给二创留了多少空间。能换场景、换配乐、换搭档的挑战，热度周期明显更长。",
        ],
      },
      {
        title: "参与时需要注意什么",
        body: [
          "跟风可以，但涉及安全动作、他人隐私或版权音乐时，还是要多留个心。好玩的前提是不给自己和他人添麻烦。",
        ],
      },
    ],
  },
  {
    id: "male-lead-growth-arcs",
    title: "热播剧男主成长线盘点：角色是怎么一步步立住的",
    category: "影视综艺",
    categorySlug: "film-tv",
    summary:
      "观众爱一个角色，多半是因为看见了他的变化。这份盘点挑选了几部热播剧的男主成长线，聊聊剧本如何用事件推动人物转变。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20open%20notebook%20with%20character%20timeline%20sketch%20and%20pen%20on%20cream%20paper%2C%20amber%20and%20terracotta%20tones%2C%20soft%20studio%20light%2C%20magazine%20photography&width=800&height=600&seq=gt-growth-10&orientation=landscape",
    coverAlt: "男主成长线盘点封面，暖色调笔记本与时间线草图静物",
    date: "2025-06-26",
    editor: "编辑 阿澈",
    readCount: 7620,
    tags: ["剧集盘点", "角色分析", "成长线"],
    isHot: false,
    isFeatured: false,
    sections: [
      {
        title: "转折点必须由事件推动",
        body: [
          "可信的成长一定来自具体事件，而不是台词里的自我宣告。角色经历了一次失败、一次抉择、一次失去，观众才会相信他真的变了。",
        ],
      },
      {
        title: "细节比宣言更有说服力",
        body: [
          "真正立得住的转变，常常体现在小动作上：从前习惯回避的眼神，后来愿意直视了；从前的急躁，后来能等一等了。",
          "这些变化不需要旁白解释，观众自己就能感受到。",
        ],
      },
      {
        title: "回看时不妨关注前后呼应",
        body: [
          "很多剧会在开头埋下伏笔，结尾再呼应。二刷时留意这些前后对照的细节，你会发现人物弧线比第一次看时更完整。",
        ],
      },
    ],
  },
];

export const faqs: GossipFaq[] = [
  {
    q: "瓜田福利社主要提供什么内容？",
    a: "我们专注娱乐与网络热点内容的聚合整理，把热门爆料、综艺名场面、剧集看点、红毯造型、音乐现场和赛场瞬间，整理成结构清晰的合集与盘点，方便你一次看完。",
  },
  {
    q: "网站内容多久更新一次？",
    a: "正常情况下每个工作日更新 3 到 5 篇盘点，遇到热点集中的时段会增加更新频率，具体以列表页的发布时间为准。",
  },
  {
    q: "合集和普通资讯有什么区别？",
    a: "普通资讯追求快，我们更看重「整理」。每篇合集都会按主题分类、标注看点，并附上相关推荐，让你不必在多个页面之间来回跳转。",
  },
  {
    q: "可以按分类或关键词查找吗？",
    a: "可以。在吃瓜合集列表页，你可以通过顶部的分类标签切换主题，也可以在搜索框输入关键词，快速定位感兴趣的内容。",
  },
  {
    q: "内容会标注来源吗？",
    a: "我们以整理和二次编辑为主，尽量在正文中说明信息背景。若发现内容存在明显错误或误会，欢迎通过联系页面向我们反馈。",
  },
  {
    q: "可以投稿或建议选题吗？",
    a: "当然可以。你可以通过联系页面提交你希望看到的选题方向，我们会在每周的选题会上统一评估，被采纳的方向会优先安排更新。",
  },
];

export const stats = [
  { label: "累计整理合集", value: "620+" },
  { label: "覆盖主题分类", value: "6 大类" },
  { label: "每月更新盘点", value: "120 篇" },
  { label: "读者收藏次数", value: "38 万" },
];

export const testimonials = [
  {
    name: "阿哲",
    role: "通勤党",
    text: "以前刷热点要开好几个App来回跳，现在直接看合集，十分钟就能把一天的重点补齐，省心。",
  },
  {
    name: "小鹿",
    role: "追剧爱好者",
    text: "剧集盘点写得很实在，不剧透关键剧情却把看点说清楚了，用来决定要不要入坑特别有用。",
  },
  {
    name: "老陈",
    role: "内容运营",
    text: "分类整理得很清晰，找选题的时候会来翻一翻，比自己搜关键词效率高不少。",
  },
];